import Vue from "vue";

/**
 * A Vue instance used to emit events without having to depend on a common root
 * shared between the emitter and the listener.
 */
export const eventBus = new Vue();
